import { render, staticRenderFns } from "./EmailCompose.vue?vue&type=template&id=112924c4&"
import script from "./EmailCompose.vue?vue&type=script&lang=js&"
export * from "./EmailCompose.vue?vue&type=script&lang=js&"
import style0 from "./EmailCompose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports